<div class="d-flex justify-content-between align-items-center matDialogBorderBottom">
    <h4 class="matDialogTitle" mat-dialog-title>Alert!</h4>
    <span class="material-icons mb-1" mat-dialog-close>close</span>
</div>
<mat-dialog-content class="mat-typography">
    <span>Process exists with the given business key(s). Would you like to redirect to the existing process ?</span>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <material-button class='mx-4 noOutline submitColor' [text]="'Proceed to existing process'" color="primary" (buttonClicked)="openCurrentInstance()">
    </material-button>
    <ng-container *ngIf="data.isAssetToAssetCase">
        <material-button class='mx-4 noOutline submitColor' [disabled]="!data.requestId" [text]="'Update process'" color="primary" (buttonClicked)="updateRequest()">
        </material-button>
    </ng-container>
    <material-button class='noOutline' [text]="'Back to New process'" color="default" (buttonClicked)="backToNewProcesspage();closeModal()">
    </material-button>
</mat-dialog-actions>
